import type { OrderDetail } from '@/features/orders';
import { ExpectedDeliveryField, formatOrderDate, isPrePlacementStatus } from '@/features/orders';

import { DetailCard, DetailRow } from './detail-card';

/** A replacement order has no Stripe charge, so Payment Method and Transaction ID arrive null
 *  (ADO 118734). Both fall back to the same `-` `formatOrderDate` already uses for an absent
 *  date, so the row keeps its place in the card rather than rendering an empty value. */
export function OrderDetailsCard({ order }: { order: OrderDetail }) {
  const { orderMeta, status } = order;
  const viewOnly = isPrePlacementStatus(status);
  const isDelivered = status === 'delivered';
  const deliveryLabel = isDelivered ? 'Delivery Date' : 'Expected Delivery';

  return (
    <DetailCard title="Order Details">
      <DetailRow label="Order Date" value={formatOrderDate(orderMeta.orderDate)} />
      <DetailRow label="Payment Method" value={orderMeta.paymentMethod ?? '-'} />
      <DetailRow
        label="Payment Date"
        // 122372 §3e — "Nil" before payment; a placed order with no date keeps "-" (ADO 118734).
        value={viewOnly ? 'Nil' : formatOrderDate(orderMeta.paymentDate)}
      />
      <DetailRow
        label={deliveryLabel}
        value={<ExpectedDeliveryField order={order} />}
        muted={viewOnly}
      />
      <DetailRow label="Transaction ID" value={orderMeta.transactionId ?? '-'} />
    </DetailCard>
  );
}
